export const GET_COORDINATES_PROBLEMS = 'GET_COORDINATES_PROBLEMS';
export const GET_COORDINATES_RESULT = 'GET_COORDINATE_RESULT';
export const ADD_COORDINATES_PROBLEMS = 'ADD_COORDINATES_PROBLEMS';
export const DOWNLOAD_PROBLEMS = 'DOWNLOAD_PROBLEMS';

export const getCoordinatesProblems = filter => ({
  type: GET_COORDINATES_PROBLEMS,
  payload: filter
});

export const addCoordinatesProblems = filter => ({
  type: ADD_COORDINATES_PROBLEMS,
  payload: filter
});

export const getCoordinatesResult = (serial, createdDate, customer) => ({
  type: GET_COORDINATES_RESULT,
  payload: { serial, createdDate, customer }
});

export const downloadProblems = filter => ({
  type: DOWNLOAD_PROBLEMS,
  payload: filter
});

export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const GET_FILTER_OPTIONS = 'GET_FILTER_OPTIONS';
export const CLEAN_FILTER = 'CLEAN_FILTER';
export const UPDATE_ORGANIZATIONS_NAMES = 'UPDATE_ORGANIZATIONS_NAMES';
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';

export const updateFilter = filter => ({
  type: UPDATE_FILTER,
  payload: filter
});

export const cleanFilter = () => ({
  type: CLEAN_FILTER
});

export const getFilterOptions = () => ({
  type: GET_FILTER_OPTIONS
});

export const updateOrganizationsNames = organizationsNames => ({
  type: UPDATE_ORGANIZATIONS_NAMES,
  payload: organizationsNames
});

export const updateCustomer = customer => ({
  type: UPDATE_CUSTOMER,
  payload: customer
});

export const getOrganizations = (customer) => ({
  type: GET_ORGANIZATIONS,
  payload: customer
});

export const AUTH_REQUEST = 'AUTH_REQUEST';
export const UNAUTHORIZE = 'UNAUTHORIZE';
export const CLEAN_STATE = 'CLEAN_STATE';

export const authorize = (username, password) => ({
  type: AUTH_REQUEST,
  payload: { username, password }
});

export const unauthorize = () => ({
  type: UNAUTHORIZE
});

export const cleanState = () => ({
  type: CLEAN_STATE
});


// WEBPACK FOOTER //
// ./src/sagas/actions.js